<h3 *ngIf="data == null" modal-title>Cadastrar Oportunidade</h3>
<h3 *ngIf="data != null" modal-title>Alterar Oportunidade</h3>

<div modal-body  mat-dialog-content>

    <div fxLayout="row wrap" *ngIf="showClientField">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%" *ngIf="isEdit()" >
            <mat-label>Cliente</mat-label>
            <input matInput aria-label="Cliente" [formControl]="cliente_edit" name="cliente">
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%" *ngIf="!isEdit()" >
            <mat-label>Cliente</mat-label>
            <input matInput placeholder="Digite o nome ou conta de um cliente" aria-label="Cliente"  [formControl]="cliente" name="cliente" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"  (optionSelected)='getCliente($event.option.value)'>
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{cliente.nome}}</span> |
                    <small>Conta: {{cliente.numero_xp }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>

    
    <div fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Assunto</mat-label>
            <mat-select 
                placeholder="Assunto"
                [(value)]="model.tipo_oportunidade_id" 
                [formControl]="tipo_oportunidade_id"
                name="tipo_oportunidade_id"
                required
                [disabled]="isEdit()"
            >
                <mat-option value="">SELECIONE</mat-option>
                <mat-option *ngFor="let tipo of listTipo" [value]="tipo.id">{{tipo.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerTipo"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="row wrap">
        <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
            <mat-label>Data da Oportunidade</mat-label>
            <input 
                matInput 
                [matDatepicker]="picker" 
                [formControl]="data_oportunidade" 
                name="data_oportunidade" 
                required
                placeholder="Data da Oportunidade"
                [readonly]="true">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>

    <div fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Data Retorno</mat-label>
            <input 
                matInput 
                [min]="todayDate"
                [matDatepicker]="retorno" 
                [formControl]="data_retorno" 
                name="data_retorno" 
                required
                placeholder="Retornar em"
                [readonly]="true">
            <mat-datepicker-toggle matSuffix [for]="retorno"></mat-datepicker-toggle>
            <mat-datepicker #retorno></mat-datepicker>
        </mat-form-field>
    </div>

    <div fxLayout="row wrap">
        <mat-form-field  appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Valor</mat-label>
            <input 
                matInput 
                placeholder="Valor" 
                [formControl]="valor" 
                required
                currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                maxlength="50">                    
        </mat-form-field>       
    </div>

    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field style="width: 100%">
                <input 
                    matInput 
                    placeholder="Descrição" 
                    [formControl]="descricao" 
                    maxlength="255"
                />
                <mat-error *ngIf="descricao.invalid">{{getErrorNameMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>
</div>

<div mat-dialog-actions model-footer>
    
    <button 
        mat-button 
        tabindex="2" 
        (click)="onNoClick()"
    >   
        Cancelar
    </button>
    
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="salvar()" 
        tabindex="-1"
    >
        Salvar
    </button>
</div>


